import React from "react";

const PriceForm = ({ priceForm, onChange, onSubmit, onCancel }) => {
  const handleChange = (e, isImage = false) => {
    const { name, value, files } = e.target;

    if (isImage) {
      onChange({ target: { name, value: files[0] } }, true);
    } else {
      onChange(e);
    }
  };
  // console.log(areas)
  return (
    <form
      onSubmit={onSubmit}
      className="grid grid-cols-1 gap-4 p-6 bg-white rounded-lg shadow-lg w-[90%] max-w-2xl"
    >
      {/* weight Product */}
      <div className="flex flex-col">
        <label className="mb-2 text-sm font-semibold capitalize text-black ">
          Weight Product (KG)
        </label>
        <input
          type="text"
          name="weight"
          value={priceForm.weight}
          onChange={handleChange}
          required
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        />
      </div>

      <div className="flex justify-end col-span-2 mt-2 space-x-3">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-1 text-black bg-gray-300 rounded-md"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-1 text-white rounded-md bg-custom-yellow"
        >
          Save
        </button>
      </div>
    </form>
  );
};

export default PriceForm;
